exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme-picker .el-color-picker__trigger{vertical-align:middle}.theme-picker-dropdown .el-color-dropdown__link-btn{display:none}", ""]);

// exports
